"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumEventAction = exports.TealiumComponent = exports.TealiumElement = exports.TealiumFormat = exports.TealiumAction = exports.FIOC_INTERSTITIAL_GO_TO_PROFILE_BUTTON = exports.FIOC_INTERSTITIAL_CANCEL_LINK = exports.FIOC_INTERSTITIAL_CROSS_ICON = exports.FIOC_INTERSTITIAL_OPEN_MODAL = void 0;
exports.FIOC_INTERSTITIAL_OPEN_MODAL = 'FIOC_INTERSTITIAL_OPEN_MODAL';
exports.FIOC_INTERSTITIAL_CROSS_ICON = 'FIOC_INTERSTITIAL_CROSS_ICON';
exports.FIOC_INTERSTITIAL_CANCEL_LINK = 'FIOC_INTERSTITIAL_CANCEL_LINK';
exports.FIOC_INTERSTITIAL_GO_TO_PROFILE_BUTTON = 'FIOC_INTERSTITIAL_GO_TO_PROFILE_BUTTON';
var TealiumAction;
(function (TealiumAction) {
    TealiumAction["CLOSE"] = "close";
    TealiumAction["OPEN"] = "open";
    TealiumAction["CLICK"] = "click";
})(TealiumAction || (exports.TealiumAction = TealiumAction = {}));
var TealiumFormat;
(function (TealiumFormat) {
    TealiumFormat["MODAL"] = "modal";
    TealiumFormat["ICON"] = "icon";
    TealiumFormat["BUTTON"] = "button";
    TealiumFormat["LINK"] = "link";
})(TealiumFormat || (exports.TealiumFormat = TealiumFormat = {}));
var TealiumElement;
(function (TealiumElement) {
    TealiumElement["FULL"] = "full";
    TealiumElement["CROSS"] = "cross";
})(TealiumElement || (exports.TealiumElement = TealiumElement = {}));
var TealiumComponent;
(function (TealiumComponent) {
    TealiumComponent["FIOC_MODAL"] = "modal/updateKyc";
})(TealiumComponent || (exports.TealiumComponent = TealiumComponent = {}));
var TealiumEventAction;
(function (TealiumEventAction) {
    TealiumEventAction["UPDATE_KYC_MODAL"] = "updateKycModal";
    TealiumEventAction["CLICK_LINK"] = "clickLink";
    TealiumEventAction["CLICK_BUTTON"] = "clickButton";
})(TealiumEventAction || (exports.TealiumEventAction = TealiumEventAction = {}));
//# sourceMappingURL=actions.constants.js.map